import React from 'react';
import classNames from 'classnames';
import { InputRadio, LoadingBar } from '@/components/shared';
import { type AccountId } from '@/generated/data.schemas';
import styles from './CustomerRadio.module.scss';

interface CustomerRadioProps {
	className?: string;
	customerId: AccountId;
	customerName?: string;
	customerNumber?: string | null;
	owner?: string;
	checked: boolean;
	isSkeleton?: boolean;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CustomerRadio: React.FunctionComponent<CustomerRadioProps> = ({
	className,
	customerId,
	customerName,
	customerNumber,
	owner,
	checked,
	isSkeleton,
	onChange,
}) => {
	const renderLabel = () => {
		if (isSkeleton) {
			return (
				<div className={styles.skeletonWrapper}>
					<LoadingBar width={'75%'} />
					<LoadingBar className={'u-mt-sm'} width={'50%'} />
					<LoadingBar className={'u-mt-2xs'} width={'50%'} />
				</div>
			);
		}

		return (
			<div className={styles.innerWrapper}>
				<h3 className={styles.labelTitle}>{customerName}</h3>
				<p className={styles.labelBody}>
					{customerNumber ? <span>{customerNumber}</span> : null}
					{owner ? <span>{owner}</span> : null}
				</p>
			</div>
		);
	};

	return (
		<InputRadio
			className={classNames(styles.wrapper, className)}
			name={'customer'}
			label={renderLabel()}
			id={customerId.toString()}
			value={customerId}
			checked={checked}
			onChange={onChange}
			disabled={isSkeleton}
		/>
	);
};
